import { Injectable, inject } from "@angular/core";
import {Store} from "@ngrx/store";
import {Router, UrlTree} from "@angular/router";
import {Observable, withLatestFrom} from "rxjs";
import {map} from "rxjs/operators";
import {SharedLoginSelectors} from "@shared/components/login/store/shared-login.selector-type";

@Injectable({
  providedIn: 'root'
})
export class LinkIssueGuard {
  private _store = inject(Store);
  private _router = inject(Router);


  canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {

    return this._store.select(
      SharedLoginSelectors.selectHasLinkFeature(f => f.isIssueHistoryVisible),
    ).pipe(
      withLatestFrom(
        this._store.select(SharedLoginSelectors.selectHasLinkFeature(f => f.isIssueTemplateVisible)),
        this._store.select(SharedLoginSelectors.selectLinkResource).pipe(map(r => r?.resourceId))
      ),
      map(([isHistory, isTemplates, resourceId]) => {
        if (isHistory) return true
        if (isTemplates && !isHistory) return this._router.createUrlTree(['link', resourceId, 'issues', 'templates']);
        return this._router.createUrlTree(['link', 'error']);
      })
    );
  }
}
